import { render, staticRenderFns } from "./avalicacao-comportamento.vue?vue&type=template&id=1f4c87bd&"
import script from "./avalicacao-comportamento.vue?vue&type=script&lang=js&"
export * from "./avalicacao-comportamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports